/**
 * Enum values for the customer data
 */
export enum CustomerDataType {
  BIRTHDAY = 'birthday',
  COMPANY = 'company',
  EMAIL = 'email',
  FIRSTNAME = 'firstName',
  LASTNAME = 'lastName',
  MOBILEPHONE = 'mobilePhone',
  SALUTATION = 'salutation',
  STANDARDADDRESS = 'standardAddress',
  TITLE = 'title',
}
